import { CASTLE_PLOT_TYPES, FIELD_PLOT_TYPES } from '@sk/shared';
// Раскладка участков в изометрических локациях.
// Замок: сетка 13×13 — участки стоят кварталами (через клетку), между ними улицы, поэтому большие
// здания не закрывают соседей. Ратуша в центре, проспект от ворот до ворот (u = 6), в двух углах —
// пруд и роща. На ресурсной карте — по одному постоянному месту на каждый вид добычи.

export interface Cell {
  u: number;
  v: number;
}

export interface TownLayout {
  kind: 'castle' | 'field';
  cols: number;
  rows: number;
  /** Номер участка → клетка. */
  plots: Cell[];
  /** Улицы и тропинки (без участков). */
  roads: Cell[];
  /** Клетка ратуши (только в замке). */
  center: Cell | null;
  /** Украшения внутри стен: пруды и рощи. */
  decor: (Cell & { kind: 'pond' | 'grove' })[];
  /** Ворота: столбец проспекта. */
  gateU: number | null;
}

function castleLayout(): TownLayout {
  const N = 13;
  const center = { u: 6, v: 6 };
  const decor: TownLayout['decor'] = [
    { u: 0, v: 0, kind: 'grove' },
    { u: 12, v: 12, kind: 'pond' },
  ];
  const plots: Cell[] = [];
  const roads: Cell[] = [];
  for (let v = 0; v < N; v++) {
    for (let u = 0; u < N; u++) {
      if (u === center.u && v === center.v) continue;
      if (decor.some((d) => d.u === u && d.v === v)) continue;
      if (u % 2 === 0 && v % 2 === 0 && u !== center.u) plots.push({ u, v });
      else roads.push({ u, v });
    }
  }
  return { kind: 'castle', cols: N, rows: N, plots, roads, center, decor, gateU: center.u };
}

function fieldLayout(): TownLayout {
  return {
    kind: 'field',
    cols: 5,
    rows: 1,
    plots: Array.from({ length: 5 }, (_, u) => ({ u, v: 0 })),
    roads: [],
    center: null,
    decor: [],
    gateU: null,
  };
}

export const CASTLE_LAYOUT = castleLayout();
export const FIELD_LAYOUT = fieldLayout();

/**
 * Районы новой карты замка. Координаты каждого типа задаются в townSceneConfig.json.
 * Тип задаёт постоянное место здания; несколько одинаковых зданий образуют один район.
 */
/** Постоянные участки зданий — общие с сервером (заброшенные замки строятся на тех же участках). */
export const CASTLE_FIXED_TYPES = CASTLE_PLOT_TYPES;

/** Ровно один постоянный район для каждого добывающего здания. */
export const FIELD_FIXED_TYPES = FIELD_PLOT_TYPES;

export function plotAt(layout: TownLayout, u: number, v: number): number {
  return layout.plots.findIndex((c) => c.u === u && c.v === v);
}
